"use client";

import React from "react";
import ImageCarousel_Layout1 from "./ImageCarousel/Layout1";

interface Button {
  id: string;
  url: string;
  text: string;
  type: string;
  newTab: boolean;
}

interface Picture {
  data: {
    id: string;
    attributes: {
      url: string;
      name: string;
      alternativeText: string;
      width: number;
      height: number;
    };
  };
}

interface ScrollProps {
  id: string; // Add this missing property
  title: string;
  subtitle: string;
  image: Picture;
  layoutType?: string;
}

interface ImageCarouselProps {
  data: {
    id: string;
    scroll: ScrollProps[];
    title: string;
    description: string;
    button: Button;
    isLive: boolean;
    useH1Tag: boolean;
  };
}

export default function ImageCarousel({ data }: ImageCarouselProps) {
  if (!data.isLive) return null;

  return (
    <ImageCarousel_Layout1 data={data as any} />
  );
}